export default {
  CAFETERIAS_LIST: "Cafeterias list",
  ADD_CAFETERIA: "Add cafeteria",
  CAFETERIA_ADDED: "Cafeteria added",
  EDIT_CAFETERIA: "Update cafeteria",
  CAFETERIA_UPDATED: "Cafeteria updated",
  DELETE_THIS_CAFETERIA: "Delete this cafeteria ?",
  CAFETERIA_DELETED: "Cafeteria deleted",
  OPERATION_TYPE: "Operation type",
  OPERATION_TYPE_PRODUCTION: "Production cafeteria",
  OPERATION_TYPE_SATELLITE: "Satellite cafeteria",
  OPERATION_TYPE_AUTONOMOUS: "Autonomous cafeteria",
  ORDER_TYPE: "Order Type",
  ORDER_TYPE_ONLINE: "Online Order",
  ORDER_TYPE_COUNTER: "Counter Order",
  SERVICE_OPTIONS: "Service Options",
  SERVICE_OPTION_BREAKFAST_ON_DEMAND: "Breakfast on Demand",
  SERVICE_OPTION_SNACK_BAR: "Snack Bar",
  SERVICE_OPTION_HOT_TABLE_ONE: "Hot Table (1 choice)",
  SERVICE_OPTION_HOT_TABLE_TWO: "Hot Table (2 choices)",
  SERVICE_OPTION_PANINI_ON_DEMAND: "Panini on Demand",
  SERVICE_OPTION_STIR_FRY: "Stir Fry",
  SERVICE_OPTION_PASTA_BAR: "Pasta Bar",
  SERVICE_OPTION_READY_TO_EAT_COLD: "Ready-to-eat Cold",
  SERVICE_OPTION_READY_TO_EAT_HOT: "Ready-to-eat Hot",
  SERVICE_OPTION_OTHER: "Other",
  SERVICE_OPTION_OTHER_DETAIL: 'Specify the "Other" option',
  SERVICE_OPTION_OTHER_DETAIL_PLACEHOLDER: "Describe the service option",
  NOTE: "Note",
  NOTE_PLACEHOLDER: "Note",
  INTERNAL_ORDER_DISCOUNT: "Internal order rebate",
  INTERNAL_ORDER_DISCOUNT_HELP:
    "Rebate applied automatically to every internal order this production cafeteria is the source of. A percentage applies as-is on each week; a fixed amount is prorated across each invoiced day. Leave the value at zero to apply no rebate.",
  INTERNAL_ORDER_DISCOUNT_TYPE: "Rebate type",
  INTERNAL_ORDER_DISCOUNT_TYPE_PERCENTAGE: "Percentage",
  INTERNAL_ORDER_DISCOUNT_TYPE_AMOUNT: "Fixed amount",
  INTERNAL_ORDER_DISCOUNT_VALUE_PERCENTAGE: "Percentage (%)",
  INTERNAL_ORDER_DISCOUNT_VALUE_AMOUNT: "Amount ($)",
  INTERNAL_ORDER_DISCOUNT_NAME: "Label",
  INTERNAL_ORDER_DISCOUNT_NAME_PLACEHOLDER: "RABAIS",
  PRODUCIBLE_PRODUCTS: "Producible products",
  PRODUCIBLE_PRODUCTS_EXPLANATION:
    "Products this production cafeteria can produce, picked among the establishment warehouse products. Only these products will be offered in internal orders. When the list is empty, every warehouse product is offered.",
  ADD_PRODUCIBLE_PRODUCTS: "Add products",
  PRODUCIBLE_PRODUCTS_UPDATED: "Producible products list updated",
  REMOVE_THIS_PRODUCIBLE_PRODUCT: "Remove this product from the list?",
  PRODUCIBLE_PRODUCTS_EMPTY:
    "No product configured: every product of the establishment warehouse is offered in internal orders.",
  PRODUCIBLE_PRODUCTS_NO_WAREHOUSE:
    "The establishment of this cafeteria has no warehouse: no producible products list can be configured.",
};
